export const walletSettingsEnum = {
  unknown: 'Unknown',
  nickname: 'Nickname',
  autoFunding: 'AutoFunding',
  defaultPurchaseAmount: 'DefaultPurchaseAmount',
  updatePaymentMethod: 'UpdatePaymentMethod',
  reportsLink: 'ReportsLink',
  balanceHistory: 'BalanceHistory',
};

export const walletSellerProviderSettingsEnum = {
  unknown: 'Unknown',
  refreshServices: 'RefreshServices',
  accountSettingsLink: 'AccountSettingsLink',
  updatePassword: 'UpdatePassword',
  setAsPreferredAccount: 'SetAsPreferredAccount',
};
